import React, { useEffect, useRef, useState } from 'react';
import ChartPanel from './ChartPanel';
import server from '../../utils/serverConfig';
import './OptionsLiveChart.css';

const OptionsLiveChart = () => {
  const wsRef = useRef(null);
  const [wsStatus, setWsStatus] = useState('CONNECTING');
  
  const p1 = useRef(null);
  const p2 = useRef(null);
  const p3 = useRef(null);
  const p4 = useRef(null);
  const panels = { chart1: p1, chart2: p2, chart3: p3, chart4: p4 };

  const connectWS = () => {
    // Generate websocket URL dynamically from config
    const wsBaseUrl = server.godseye.baseUrl.replace(/^http/, 'ws');
    const wsUrl = `${wsBaseUrl}ws/chart`;
    
    setWsStatus('CONNECTING');
    const ws = new WebSocket(wsUrl);
    
    ws.onopen = () => {
      setWsStatus('LIVE');
    };
    
    ws.onmessage = (e) => {
      try {
        const data = JSON.parse(e.data);
        const chartId = data.chart_id || 'chart1';
        const panelRef = panels[chartId];
        if (panelRef && panelRef.current) {
          panelRef.current.handleMsg(data);
        }
      } catch (err) {
        console.error("WS Parse error", err);
      }
    };
    
    ws.onerror = () => {
      setWsStatus('ERROR');
    };
    
    ws.onclose = () => {
      setWsStatus('RETRYING…');
      setTimeout(connectWS, 3000);
    };
    
    wsRef.current = ws;
  };

  useEffect(() => {
    connectWS();
    return () => {
      if (wsRef.current) wsRef.current.close();
    };
    // eslint-disable-next-line
  }, []);

  const sendAction = (payload) => {
    if (wsRef.current && wsRef.current.readyState === WebSocket.OPEN) {
      wsRef.current.send(JSON.stringify(payload));
    }
  };

  const getWsDotClass = () => {
    if (wsStatus === 'LIVE') return 'connected';
    if (wsStatus === 'ERROR') return 'error';
    return '';
  };

  return (
    <div className="options-chart-container" style={{ width: '100%', height: 'calc(100vh - 60px)', display: 'flex', flexDirection: 'column' }}>
      <div id="navbar">
        <div id="brand">LIVE US OPTION CHARTS</div>
        <div id="wsIndicator" className={getWsDotClass()}>
          <div id="wsDot"></div>
          <span id="wsText">{wsStatus}</span>
        </div>
      </div>
      
      <div id="workspace">
        <div className="chart-row">
          <ChartPanel n={1} ref={p1} onAction={sendAction} />
          <div className="col-divider"></div>
          <ChartPanel n={2} ref={p2} onAction={sendAction} />
        </div>
        <div id="row-divider"></div>
        <div className="chart-row">
          <ChartPanel n={3} ref={p3} onAction={sendAction} />
          <div className="col-divider"></div>
          <ChartPanel n={4} ref={p4} onAction={sendAction} />
        </div>
      </div>
    </div>
  );
};

export default OptionsLiveChart;
